// FAQ-data separerad från guidekomponenten så att route-huvudet (JSON-LD)
// kan importera den utan att dra in hela guiden i startbundlen.
export const ALDERSKONTROLL_FAQS: { q: string; a: string }[] = [
  {
    q: "Vid vilken ålder gäller åldersgränsen för alkoholservering?",
    a: "18 år. Enligt 3 kap. 7–8 §§ alkohollagen (2010:1622) får alkoholdrycker inte lämnas ut eller serveras till den som inte har fyllt 18 år. Det gäller all servering, oavsett vilken typ av serveringstillstånd verksamheten har.",
  },
  {
    q: "Varför ber personal ofta om legitimation även av 20-åringar?",
    a: "25-årsregeln är inte ett lagkrav utan en branschpraxis. Genom att kräva legitimation av alla som ser ut att vara under 25 år får personalen en tydlig, konsekvent regel att luta sig mot i stället för att gissa gästens ålder, vilket minskar risken att servera till någon under 18 år.",
  },
  {
    q: "Vilka id-handlingar ska personalen godta?",
    a: "Svenskt körkort, svenskt nationellt id-kort, SIS-märkt id-kort, id-kort utfärdat av Skatteverket samt pass är de handlingar som normalt godtas. Kopior, foton i mobilen eller handlingar utan foto och födelsedatum ska inte godtas som bevis på ålder.",
  },
  {
    q: "Vad ska personalen göra vid tveksamma fall?",
    a: "Regeln är enkel: ingen giltig legitimation, ingen alkohol. Beslutet ska inte förhandlas med gästen i stunden. Är åldern fortfarande osäker efter uppvisad legitimation ska servering nekas och händelsen noteras i loggen.",
  },
  {
    q: "Vad är langning och varför är det förbjudet?",
    a: "Langning innebär att en person som fått alkohol serverad eller köpt den lämnar den vidare till någon som är under 18 år eller till någon som redan nekats servering. Det är förbjudet enligt 3 kap. 9 § alkohollagen, och serveringsstället bör ha rutiner för att upptäcka och förhindra att detta sker i lokalen.",
  },
  {
    q: "Får man servera alkohol till en person som är märkbart påverkad?",
    a: "Nej. Enligt 3 kap. 8 § alkohollagen får alkoholdrycker inte serveras till den som är märkbart påverkad av alkohol eller andra medel, oavsett ålder. Ålderskontroll och kontroll av påverkansgrad hör ihop och ska ingå i samma rutin.",
  },
  {
    q: "Vad är ett kontrollköp?",
    a: "Ett kontrollköp är en test där en person, oftast strax under eller nära åldersgränsen, försöker köpa eller bli serverad alkohol under kommunens eller polisens överinseende för att kontrollera att ålderskontrollen fungerar i praktiken. Misslyckade kontrollköp är en vanlig grund för anmärkning vid tillsyn.",
  },
  {
    q: "Vilka sanktioner kan bli aktuella om ålderskontrollen brister?",
    a: "Kommunen kan enligt 9 kap. 17–18 §§ alkohollagen meddela erinran vid mindre brister, varning vid allvarligare eller upprepade brister, och i de tyngsta fallen återkalla serveringstillståndet. Servering till minderårig är en av de överträdelser som bedöms strängast vid tillsyn.",
  },
  {
    q: "Ska nekad servering på grund av ålder dokumenteras?",
    a: "Ja. En logg med datum, tidpunkt, kort beskrivning och vem som fattade beslutet är ett starkt bevis vid tillsyn på att ålderskontrollen faktiskt tillämpas i vardagen, inte bara finns på pappret.",
  },
  {
    q: "Gäller samma åldersgräns för folköl i butik som för servering på restaurang?",
    a: "Åldersgränsen 18 år gäller i båda fallen, men regelverket skiljer sig åt: försäljning av folköl i butik regleras i 5 kap. alkohollagen med krav på egentillsyn och anmälan till kommunen, medan servering på restaurang eller liknande kräver serveringstillstånd enligt 8 kap. och prövas mot samma 18-årsgräns i 3 kap.",
  },
];
